import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-status-label',
  templateUrl: './booking-status-label.component.html',
  styleUrls: ['./booking-status-label.component.scss'],
})
export class BookingStatusLabelComponent implements OnInit {
  @Input() statusClass;
  @Input() statusTitle;

  constructor() {}

  ngOnInit(): void {}
}
